import { WorkforcePlanningAllowedActionControllerApi } from '~/common/api';
import { useFetch } from '~/common/hooks/use-fetch';

const useFetchWorkforcePlanningAllowedAction = () => {
  return useFetch('/api/workforce-plannings/allowed-actions/me', async (reqOps) => {
    return new WorkforcePlanningAllowedActionControllerApi()
      .fetchAllowedActions(reqOps)
      .then(({ data }) => data);
  });
};

export { useFetchWorkforcePlanningAllowedAction };
